// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"wmf-a0egSz6H","uploadqr":"wmf-3MMUIpc8","delete_icon":"wmf-3GUZAY_6"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/brandwx/editbrandwx.module.less
// module id = 1155
// module chunks = 0